export function parseCurrencyToNumber(value) {
    if (!value)
        return 0;
    const normalized = value
        .replace(/[^\d,-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    return Number(normalized) || 0;
}
